import { getParsedData } from "../../assets/helpers/getParsedData.js";
import store from "@/store";

export default {
  async SEND_BUG_REPORT({ getters }) {
    const e = getters.REPORT_SNACKBAR.errorData
    if (!e) {
      throw new Error('Отсутствует информация об ошибке')
    }
    if (e.config.data instanceof FormData) {
      const dataCopy = {}

      e.config.data.forEach((value, key) => {
        dataCopy[key] = getParsedData(value)
      })

      e.config.data = JSON.stringify(dataCopy)
    }

    const errorInfo = {
      description: e?.description || 'Нет данных',
      url: e.config.url,
      params: e.config.params,
      method: e.config.method,
      sent_data: getParsedData(e.config.data),
      status: e.response.status,
      statusText: e.response.statusText,
      response_data: e.response.data.length <= 500 ? [e.response.data] : 'Слишком большие данные для отображения ответа',
    }

    await store.dispatch('customRequests/POST', {
      path: '/bug-report',
      data: errorInfo
    })
  }
}
